import { noveltyCheckContainer } from './domains';

export { NoveltySearchContainer } from './domains';
export { default as FtoContainer } from './components/containers/FtoContainer.vue';
export { default as DesignFtoSearchContainer } from './components/containers/DesignFtoSearchContainer.vue';
export const checkingContainers = [noveltyCheckContainer];
